import { useEffect, useMemo, useState } from "react";
import "./App.css";

const BASE_TOKENS = [
  {
    slug: "burgerverse",
    name: "Burgerverse",
    ticker: "$BURG",
    image: "/placeholders/ph1.webp",
    status: "Hot",
    blurb: "Fast-moving meme token with a greasy cult following and strong early volume.",
    marketCap: "$412K",
    marketCapValue: 412000,
    volume: "$96K",
    volumeValue: 96000,
    creator: "mealprinter",
    creatorWallet: "0x8134...B19D",
    ageMinutes: 14,
    change: "+28.4%",
    price: "$0.000412",
    ath: "$684K",
    holders: "1,284",
    holdersValue: 1284,
    bondProgress: 78,
    graduationMcap: "$528K",
    amountRequired: "22.4 SOL",
    amountRequiredUsd: "$3,184",
    chain: "Solana",
    website: "burgerverse.fun",
    social: "@burgerverse",
    contract: "BURG...FUN",
    about:
      "Burgerverse is a loud, fast-moving community coin built around greasy internet energy, late-night raids, and a feed that never really cools off.",
    comments: [
      { user: "comboalpha", age: "8m ago", text: "Strong opener. This one feels sticky.", conviction: "2.1x" },
      { user: "drivefries", age: "26m ago", text: "Volume stayed healthy through the first rotation.", conviction: "1.6x" },
      { user: "nightcook", age: "1h ago", text: "Branding is dialed. Feels built to travel.", conviction: "1.3x" },
    ],
    trades: [
      { wallet: "8fQ2...7mL9", side: "Buy", amount: "3.2 SOL", tokens: "12.4K", time: "2m ago" },
      { wallet: "B12k...Pq8n", side: "Sell", amount: "1.1 SOL", tokens: "4.0K", time: "5m ago" },
      { wallet: "4Hsa...Lm22", side: "Buy", amount: "5.7 SOL", tokens: "20.8K", time: "9m ago" },
      { wallet: "91Zc...Qp72", side: "Buy", amount: "0.8 SOL", tokens: "3.1K", time: "13m ago" },
    ],
    holdersTable: [
      { wallet: "mealprinter", share: "14.2%", entry: "$120K", pnl: "+$88K" },
      { wallet: "comboalpha", share: "6.9%", entry: "$210K", pnl: "+$34K" },
      { wallet: "latebite", share: "4.4%", entry: "$302K", pnl: "+$19K" },
      { wallet: "greasegod", share: "3.8%", entry: "$150K", pnl: "-$6K" },
    ],
  },
  {
    slug: "fries-club",
    name: "Fries Club",
    ticker: "$FRIES",
    image: "/placeholders/ph2.webp",
    status: "New",
    blurb: "Crunchy community energy, clean branding, and a lot of fresh-holder momentum.",
    marketCap: "$188K",
    marketCapValue: 188000,
    volume: "$44K",
    volumeValue: 44000,
    creator: "crispydev",
    creatorWallet: "0x44C8...7781",
    ageMinutes: 39,
    change: "+12.7%",
    price: "$0.000188",
    ath: "$244K",
    holders: "932",
    holdersValue: 932,
    bondProgress: 31,
    graduationMcap: "$302K",
    amountRequired: "61.8 SOL",
    amountRequiredUsd: "$8,790",
    chain: "Solana",
    website: "friesclub.io",
    social: "@friesclub",
    contract: "FRIE...CLUB",
    about:
      "Fries Club leans into clean meme branding and approachable launch energy, with a community that wants a simple, fast-moving feed coin.",
    comments: [
      { user: "saltqueen", age: "12m ago", text: "Feels easier to onboard normies into this one.", conviction: "1.4x" },
      { user: "windowthree", age: "21m ago", text: "Healthy first-hour spread and no weird chop yet.", conviction: "1.2x" },
      { user: "trayflip", age: "33m ago", text: "The visual identity is carrying hard.", conviction: "1.1x" },
    ],
    trades: [
      { wallet: "Hs9Q...3LmA", side: "Buy", amount: "1.8 SOL", tokens: "8.9K", time: "3m ago" },
      { wallet: "4sa1...Dk92", side: "Buy", amount: "0.7 SOL", tokens: "3.3K", time: "11m ago" },
      { wallet: "AR9m...Pw87", side: "Sell", amount: "0.4 SOL", tokens: "1.9K", time: "19m ago" },
      { wallet: "Qp21...Hn77", side: "Buy", amount: "2.4 SOL", tokens: "11.0K", time: "28m ago" },
    ],
    holdersTable: [
      { wallet: "crispydev", share: "11.8%", entry: "$86K", pnl: "+$17K" },
      { wallet: "saltqueen", share: "5.1%", entry: "$94K", pnl: "+$8K" },
      { wallet: "trayflip", share: "4.9%", entry: "$132K", pnl: "+$6K" },
      { wallet: "crinklebag", share: "3.2%", entry: "$120K", pnl: "-$2K" },
    ],
  },
  {
    slug: "snack-attack",
    name: "Snack Attack",
    ticker: "$SNAX",
    image: "/placeholders/ph3.jpg",
    status: "Live",
    blurb: "Built for fast sessions, quick socials, and chaotic meme velocity.",
    marketCap: "$625K",
    marketCapValue: 625000,
    volume: "$132K",
    volumeValue: 132000,
    creator: "latewindow",
    creatorWallet: "0x71BE...9C03",
    ageMinutes: 120,
    change: "+41.2%",
    price: "$0.000625",
    ath: "$712K",
    holders: "2,091",
    holdersValue: 2091,
    bondProgress: 91,
    graduationMcap: "$748K",
    amountRequired: "8.7 SOL",
    amountRequiredUsd: "$1,238",
    chain: "Solana",
    website: "snackattack.fun",
    social: "@snackattack",
    contract: "SNAX...ACK",
    about:
      "Snack Attack is made for constant feed action, quick headline moments, and the kind of chart that keeps people checking back all night.",
    comments: [
      { user: "vaultvision", age: "10m ago", text: "This is the fastest tape on the menu right now.", conviction: "2.9x" },
      { user: "nightwindow", age: "32m ago", text: "Best liquidity profile on the board today.", conviction: "2.0x" },
      { user: "sideshow", age: "1h ago", text: "Holding trend is cleaner than it has any right to be.", conviction: "1.5x" },
    ],
    trades: [
      { wallet: "Pw9L...2qWs", side: "Buy", amount: "7.9 SOL", tokens: "21.6K", time: "1m ago" },
      { wallet: "Nq88...7kAa", side: "Sell", amount: "2.2 SOL", tokens: "5.8K", time: "4m ago" },
      { wallet: "4cD9...xA72", side: "Buy", amount: "9.4 SOL", tokens: "25.1K", time: "8m ago" },
      { wallet: "Y7Lm...pQ12", side: "Buy", amount: "3.1 SOL", tokens: "8.0K", time: "12m ago" },
    ],
    holdersTable: [
      { wallet: "latewindow", share: "8.3%", entry: "$402K", pnl: "+$55K" },
      { wallet: "vaultvision", share: "6.2%", entry: "$480K", pnl: "+$36K" },
      { wallet: "snackpack", share: "5.4%", entry: "$511K", pnl: "+$22K" },
      { wallet: "crisptrain", share: "2.8%", entry: "$620K", pnl: "-$8K" },
    ],
  },
  {
    slug: "combo-cash",
    name: "Combo Cash",
    ticker: "$MEAL",
    image: "/placeholders/ph4.avif",
    status: "Trending",
    blurb: "Simple launch, big engagement, and surprisingly sticky buy pressure.",
    marketCap: "$904K",
    marketCapValue: 904000,
    volume: "$201K",
    volumeValue: 201000,
    creator: "drivefries",
    creatorWallet: "0x5A82...113B",
    ageMinutes: 240,
    change: "+18.5%",
    price: "$0.000904",
    ath: "$1.13M",
    holders: "2,844",
    holdersValue: 2844,
    bondProgress: 64,
    graduationMcap: "$1.02M",
    amountRequired: "29.9 SOL",
    amountRequiredUsd: "$4,252",
    chain: "Solana",
    website: "combocash.club",
    social: "@combocash",
    contract: "MEAL...ASH",
    about:
      "Combo Cash is the broad-audience menu coin: easy to understand, visually loud, and positioned to feel like the center of the HappiMeal feed.",
    comments: [
      { user: "comboalpha", age: "6m ago", text: "Still the cleanest chart in the app.", conviction: "1.9x" },
      { user: "papertray", age: "41m ago", text: "Big engagement without looking overextended yet.", conviction: "1.5x" },
      { user: "heatlamp", age: "2h ago", text: "This one is probably the homepage face for a while.", conviction: "1.4x" },
    ],
    trades: [
      { wallet: "2vS1...0Qpm", side: "Buy", amount: "11.2 SOL", tokens: "33.7K", time: "3m ago" },
      { wallet: "8wN2...4Lqa", side: "Sell", amount: "4.4 SOL", tokens: "12.8K", time: "9m ago" },
      { wallet: "Ba3R...yP00", side: "Buy", amount: "2.6 SOL", tokens: "7.7K", time: "15m ago" },
      { wallet: "T9Qm...3Ktp", side: "Buy", amount: "6.1 SOL", tokens: "17.9K", time: "22m ago" },
    ],
    holdersTable: [
      { wallet: "drivefries", share: "9.5%", entry: "$700K", pnl: "+$102K" },
      { wallet: "comboalpha", share: "6.8%", entry: "$804K", pnl: "+$58K" },
      { wallet: "papertray", share: "4.7%", entry: "$611K", pnl: "+$33K" },
      { wallet: "heatlamp", share: "3.4%", entry: "$908K", pnl: "-$11K" },
    ],
  },
  {
    slug: "toy-token",
    name: "Toy Token",
    ticker: "$TOY",
    image: "/placeholders/ph5.jpg",
    status: "Early",
    blurb: "Cute visuals, weird internet humor, and a meme base that keeps showing up.",
    marketCap: "$119K",
    marketCapValue: 119000,
    volume: "$22K",
    volumeValue: 22000,
    creator: "kidcorekitchen",
    creatorWallet: "0x98D0...84A1",
    ageMinutes: 7,
    change: "+7.1%",
    price: "$0.000119",
    ath: "$146K",
    holders: "441",
    holdersValue: 441,
    bondProgress: 18,
    graduationMcap: "$188K",
    amountRequired: "73.3 SOL",
    amountRequiredUsd: "$10,424",
    chain: "Solana",
    website: "toytoken.fun",
    social: "@toytoken",
    contract: "TOY...KEN",
    about:
      "Toy Token leans into bright visuals and playful internet references, with enough early traction to feel promising without losing its weirdness.",
    comments: [
      { user: "kidcorekitchen", age: "4m ago", text: "Still tiny, but the replies are sticky.", conviction: "1.2x" },
      { user: "paperhat", age: "6m ago", text: "Would not fade a chart this clean at this size.", conviction: "1.1x" },
      { user: "lunchtable", age: "7m ago", text: "Feels like something collectors would grab.", conviction: "1.1x" },
    ],
    trades: [
      { wallet: "H2kL...xP19", side: "Buy", amount: "0.9 SOL", tokens: "4.8K", time: "2m ago" },
      { wallet: "8qJd...aN53", side: "Buy", amount: "1.3 SOL", tokens: "6.7K", time: "5m ago" },
      { wallet: "X2gP...sL87", side: "Sell", amount: "0.4 SOL", tokens: "2.0K", time: "8m ago" },
      { wallet: "Qw8c...0mP4", side: "Buy", amount: "0.7 SOL", tokens: "3.5K", time: "10m ago" },
    ],
    holdersTable: [
      { wallet: "kidcorekitchen", share: "12.6%", entry: "$88K", pnl: "+$9K" },
      { wallet: "paperhat", share: "5.3%", entry: "$99K", pnl: "+$2K" },
      { wallet: "lunchtable", share: "4.1%", entry: "$104K", pnl: "+$1K" },
      { wallet: "toybox", share: "2.7%", entry: "$120K", pnl: "-$1K" },
    ],
  },
  {
    slug: "midnight-drive-thru",
    name: "Midnight Drive Thru",
    ticker: "$LATE",
    image: "/placeholders/ph6.jpg",
    status: "Soon",
    blurb: "Slow burn launch with sleeper potential and a lot of watchlist attention.",
    marketCap: "$278K",
    marketCapValue: 278000,
    volume: "$51K",
    volumeValue: 51000,
    creator: "nightshift",
    creatorWallet: "0x1F02...AA91",
    ageMinutes: 60,
    change: "+9.4%",
    price: "$0.000278",
    ath: "$321K",
    holders: "708",
    holdersValue: 708,
    bondProgress: 46,
    graduationMcap: "$360K",
    amountRequired: "44.1 SOL",
    amountRequiredUsd: "$6,272",
    chain: "Solana",
    website: "midnightdrivethru.fun",
    social: "@midnightdrivethru",
    contract: "LATE...THRU",
    about:
      "Midnight Drive Thru is built around slower, moodier momentum, with a launch profile that feels more like a sleeper watchlist pick than a first-minute sprint.",
    comments: [
      { user: "nightshift", age: "9m ago", text: "The pacing on this one is exactly right.", conviction: "1.3x" },
      { user: "afterhours", age: "27m ago", text: "Could wake up late and run hard.", conviction: "1.2x" },
      { user: "curbside", age: "48m ago", text: "One of the better names on the board.", conviction: "1.1x" },
    ],
    trades: [
      { wallet: "K9wQ...2Lpa", side: "Buy", amount: "2.2 SOL", tokens: "8.1K", time: "6m ago" },
      { wallet: "3cPm...2Qa1", side: "Sell", amount: "0.6 SOL", tokens: "2.2K", time: "13m ago" },
      { wallet: "7An9...sQ88", side: "Buy", amount: "1.7 SOL", tokens: "6.3K", time: "22m ago" },
      { wallet: "Yp11...4tNc", side: "Buy", amount: "0.8 SOL", tokens: "2.9K", time: "35m ago" },
    ],
    holdersTable: [
      { wallet: "nightshift", share: "10.1%", entry: "$220K", pnl: "+$14K" },
      { wallet: "afterhours", share: "4.8%", entry: "$248K", pnl: "+$5K" },
      { wallet: "curbside", share: "3.3%", entry: "$271K", pnl: "+$1K" },
      { wallet: "sleeperszn", share: "2.6%", entry: "$288K", pnl: "-$3K" },
    ],
  },
];

const TOKEN_VARIANTS = [
  {
    slug: "hash-browns",
    name: "Hash Browns",
    ticker: "$HASH",
    status: "New",
    marketCap: "$84K",
    marketCapValue: 84000,
    volume: "$19K",
    volumeValue: 19000,
    ageMinutes: 5,
    change: "+15.8%",
    price: "$0.000084",
    holders: "318",
    holdersValue: 318,
    bondProgress: 12,
  },
  {
    slug: "soda-pop",
    name: "Soda Pop",
    ticker: "$FIZZ",
    status: "Live",
    marketCap: "$236K",
    marketCapValue: 236000,
    volume: "$67K",
    volumeValue: 67000,
    ageMinutes: 22,
    change: "+33.1%",
    price: "$0.000236",
    holders: "816",
    holdersValue: 816,
    bondProgress: 53,
  },
  {
    slug: "secret-sauce",
    name: "Secret Sauce",
    ticker: "$SAUCE",
    status: "Hot",
    marketCap: "$1.12M",
    marketCapValue: 1120000,
    volume: "$284K",
    volumeValue: 284000,
    ageMinutes: 47,
    change: "+62.4%",
    price: "$0.00112",
    holders: "3,402",
    holdersValue: 3402,
    bondProgress: 96,
  },
  {
    slug: "drive-thru-dog",
    name: "Drive Thru Dog",
    ticker: "$DOG",
    status: "Trending",
    marketCap: "$348K",
    marketCapValue: 348000,
    volume: "$88K",
    volumeValue: 88000,
    ageMinutes: 83,
    change: "+21.6%",
    price: "$0.000348",
    holders: "1,106",
    holdersValue: 1106,
    bondProgress: 69,
  },
  {
    slug: "extra-pickles",
    name: "Extra Pickles",
    ticker: "$DILL",
    status: "Early",
    marketCap: "$72K",
    marketCapValue: 72000,
    volume: "$14K",
    volumeValue: 14000,
    ageMinutes: 11,
    change: "+8.9%",
    price: "$0.000072",
    holders: "274",
    holdersValue: 274,
    bondProgress: 9,
  },
  {
    slug: "lunch-rush",
    name: "Lunch Rush",
    ticker: "$RUSH",
    status: "Soon",
    marketCap: "$516K",
    marketCapValue: 516000,
    volume: "$121K",
    volumeValue: 121000,
    ageMinutes: 156,
    change: "+17.3%",
    price: "$0.000516",
    holders: "1,722",
    holdersValue: 1722,
    bondProgress: 87,
  },
  {
    slug: "paper-crown",
    name: "Paper Crown",
    ticker: "$KING",
    status: "Live",
    marketCap: "$163K",
    marketCapValue: 163000,
    volume: "$39K",
    volumeValue: 39000,
    ageMinutes: 31,
    change: "+11.2%",
    price: "$0.000163",
    holders: "604",
    holdersValue: 604,
    bondProgress: 38,
  },
  {
    slug: "nugget-mode",
    name: "Nugget Mode",
    ticker: "$NUGS",
    status: "Hot",
    marketCap: "$742K",
    marketCapValue: 742000,
    volume: "$176K",
    volumeValue: 176000,
    ageMinutes: 68,
    change: "+45.7%",
    price: "$0.000742",
    holders: "2,358",
    holdersValue: 2358,
    bondProgress: 93,
  },
  {
    slug: "value-menu",
    name: "Value Menu",
    ticker: "$VALUE",
    status: "New",
    marketCap: "$97K",
    marketCapValue: 97000,
    volume: "$25K",
    volumeValue: 25000,
    ageMinutes: 18,
    change: "+6.4%",
    price: "$0.000097",
    holders: "389",
    holdersValue: 389,
    bondProgress: 21,
  },
  {
    slug: "ice-cream-machine",
    name: "Ice Cream Machine",
    ticker: "$BROKE",
    status: "Trending",
    marketCap: "$431K",
    marketCapValue: 431000,
    volume: "$105K",
    volumeValue: 105000,
    ageMinutes: 210,
    change: "+24.8%",
    price: "$0.000431",
    holders: "1,493",
    holdersValue: 1493,
    bondProgress: 74,
  },
  {
    slug: "big-breakfast",
    name: "Big Breakfast",
    ticker: "$STACK",
    status: "Early",
    marketCap: "$128K",
    marketCapValue: 128000,
    volume: "$31K",
    volumeValue: 31000,
    ageMinutes: 26,
    change: "+13.5%",
    price: "$0.000128",
    holders: "522",
    holdersValue: 522,
    bondProgress: 29,
  },
  {
    slug: "last-order",
    name: "Last Order",
    ticker: "$LAST",
    status: "Soon",
    marketCap: "$289K",
    marketCapValue: 289000,
    volume: "$58K",
    volumeValue: 58000,
    ageMinutes: 320,
    change: "+10.1%",
    price: "$0.000289",
    holders: "901",
    holdersValue: 901,
    bondProgress: 58,
  },
];

const TOKENS = [
  ...BASE_TOKENS,
  ...TOKEN_VARIANTS.map((variant, index) => ({
    ...BASE_TOKENS[index % BASE_TOKENS.length],
    ...variant,
    image: `/placeholders/ph${(index % 6) + 1}.${["webp", "webp", "jpg", "avif", "jpg", "jpg"][index % 6]}`,
    contract: `${variant.ticker.replace("$", "").slice(0, 4)}...MEAL`,
    website: `${variant.slug}.fun`,
    social: `@${variant.slug.replaceAll("-", "")}`,
    about: `${variant.name} brings a fresh menu theme to the feed with an active community, steady launch momentum, and a playful identity built for fast-moving discovery.`,
    blurb: `${variant.name} is picking up attention with fresh momentum and an active early community.`,
  })),
];

const USER_PROFILES = {
  mealprinter: {
    handle: "mealprinter",
    wallet: "0x8134...B19D",
    avatar: "MP",
    role: "Creator",
    followers: "4.8K",
    following: "129",
    launches: "12",
    volume: "$1.8M",
    bio: "Grease-heavy meme launcher focused on loud branding, late-night raids, and chart-first launches.",
    created: ["burgerverse"],
    holdings: [
      { label: "Largest bag", value: "$BURG", meta: "14.2%" },
      { label: "Realized", value: "$88K", meta: "30d" },
      { label: "Best run", value: "2.1x", meta: "Conviction" }
    ],
    activity: [
      "Created Burgerverse",
      "Bought back into Burgerverse",
      "Called Snack Attack early"
    ]
  },
  crispydev: {
    handle: "crispydev",
    wallet: "0x44C8...7781",
    avatar: "CD",
    role: "Builder",
    followers: "2.2K",
    following: "84",
    launches: "5",
    volume: "$642K",
    bio: "Clean launch flows, clean charts, and a habit of keeping launches readable instead of chaotic.",
    created: ["fries-club"],
    holdings: [
      { label: "Largest bag", value: "$FRIES", meta: "11.8%" },
      { label: "Realized", value: "$17K", meta: "30d" },
      { label: "Best run", value: "1.7x", meta: "Conviction" }
    ],
    activity: [
      "Created Fries Club",
      "Added socials to Fries Club",
      "Accumulated early on Combo Cash"
    ]
  },
  latewindow: {
    handle: "latewindow",
    wallet: "0x71BE...9C03",
    avatar: "LW",
    role: "Trader",
    followers: "7.1K",
    following: "212",
    launches: "3",
    volume: "$2.6M",
    bio: "Always in the fastest tape. Prefers velocity, strong first-hour structure, and community that posts as hard as it trades.",
    created: ["snack-attack"],
    holdings: [
      { label: "Largest bag", value: "$SNAX", meta: "8.3%" },
      { label: "Realized", value: "$55K", meta: "30d" },
      { label: "Best run", value: "2.9x", meta: "Conviction" }
    ],
    activity: [
      "Created Snack Attack",
      "Bought Burgerverse",
      "Rotated out of Fries Club"
    ]
  },
  drivefries: {
    handle: "drivefries",
    wallet: "0x5A82...113B",
    avatar: "DF",
    role: "Creator",
    followers: "9.4K",
    following: "311",
    launches: "14",
    volume: "$4.4M",
    bio: "Focuses on broad-audience tokens with tight visuals, legible launches, and enough replay value to stay on the homepage.",
    created: ["combo-cash"],
    holdings: [
      { label: "Largest bag", value: "$MEAL", meta: "9.5%" },
      { label: "Realized", value: "$102K", meta: "30d" },
      { label: "Best run", value: "3.4x", meta: "Conviction" }
    ],
    activity: [
      "Created Combo Cash",
      "Bought into Snack Attack",
      "Posted a full launch thread"
    ]
  },
  kidcorekitchen: {
    handle: "kidcorekitchen",
    wallet: "0x98D0...84A1",
    avatar: "KK",
    role: "Collector",
    followers: "1.1K",
    following: "56",
    launches: "2",
    volume: "$184K",
    bio: "Collects bright internet-native launches and leans into playful visuals with smaller, sticky communities.",
    created: ["toy-token"],
    holdings: [
      { label: "Largest bag", value: "$TOY", meta: "12.6%" },
      { label: "Realized", value: "$9K", meta: "30d" },
      { label: "Best run", value: "1.4x", meta: "Conviction" }
    ],
    activity: [
      "Created Toy Token",
      "Added holders-only chat",
      "Accumulated Midnight Drive Thru"
    ]
  },
  nightshift: {
    handle: "nightshift",
    wallet: "0x1F02...AA91",
    avatar: "NS",
    role: "Sleeper",
    followers: "3.7K",
    following: "140",
    launches: "4",
    volume: "$522K",
    bio: "Prefers slower launches with more mood than noise and a community that builds over time instead of minute one.",
    created: ["midnight-drive-thru"],
    holdings: [
      { label: "Largest bag", value: "$LATE", meta: "10.1%" },
      { label: "Realized", value: "$14K", meta: "30d" },
      { label: "Best run", value: "1.9x", meta: "Conviction" }
    ],
    activity: [
      "Created Midnight Drive Thru",
      "Bought Combo Cash",
      "Called Toy Token"
    ]
  },
  comboalpha: {
    handle: "comboalpha",
    wallet: "0x71AA...3B9C",
    avatar: "CA",
    role: "Collector",
    followers: "6.2K",
    following: "98",
    launches: "0",
    volume: "$1.2M",
    bio: "Active buyer who rotates aggressively but keeps a tight list of homepage-quality launches.",
    created: [],
    holdings: [
      { label: "Largest bag", value: "$BURG", meta: "128.4K" },
      { label: "Open PnL", value: "+24.8%", meta: "Portfolio" },
      { label: "Best call", value: "Snack Attack", meta: "1st hour" }
    ],
    activity: [
      "Bought Burgerverse",
      "Bought Combo Cash",
      "Called Snack Attack"
    ]
  }
};

const PROFILE_POSITIONS = [
  { slug: "burgerverse", amount: "128,400", value: "$1,982", pnl: "+24.8%" },
  { slug: "fries-club", amount: "82,190", value: "$944", pnl: "+8.1%" },
  { slug: "combo-cash", amount: "45,000", value: "$611", pnl: "-3.2%" },
];

const FOOTER_LINKS = [
  { label: "X", href: "#", icon: "/icons/x.svg" },
  { label: "Telegram", href: "#", icon: "/icons/telegram.svg" },
  { label: "Website", href: "#", icon: "/icons/web.svg" },
];

const DETAIL_TABS = ["Trades", "Holders", "Callouts"];
const LIVE_CHART_BASE_URL =
  "https://dexscreener.com/robinhood/0x0bd7d308f8e1639fab988df18a8011f41eacad73?embed=1&loadChartSettings=0&trades=0&tabs=0&info=0";
const SEARCH_KEY = "happimeal-recent-searches";
const VIEWED_KEY = "happimeal-recent-viewed";
const SEARCH_DEBOUNCE_MS = 800;

function getInitialTheme() {
  if (typeof window === "undefined") return "light";
  const stored = window.localStorage.getItem("happimeal-theme");
  return stored === "dark" ? "dark" : "light";
}

function normalizeRoute(pathname) {
  const path = String(pathname || "/").replace(/\/+$/, "") || "/";
  if (path === "/create") return "/create";
  if (path === "/profile") return "/profile";
  if (path.startsWith("/token/")) return path;
  if (path.startsWith("/user/")) return path;
  return "/";
}

function formatCurrencyCompact(value) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    maximumFractionDigits: value >= 1000000 ? 1 : 0,
  }).format(value);
}

function formatNumberCompact(value) {
  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);
}

function formatMinutesAgo(totalMinutes) {
  const minutes = Math.max(1, Number(totalMinutes || 0));
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

function shortAddress(value) {
  const raw = String(value || "");
  if (raw.length <= 10) return raw;
  return `${raw.slice(0, 6)}...${raw.slice(-4)}`;
}

function scoreTokenSearch(token, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return 0;
  const fields = [
    token.name.toLowerCase(),
    token.ticker.toLowerCase(),
    token.creator.toLowerCase(),
    token.website.toLowerCase(),
  ];
  let score = 0;
  for (const field of fields) {
    if (field === q) score += 12;
    else if (field.startsWith(q)) score += 6;
    else if (field.includes(q)) score += 3;
  }
  return score;
}

function readStoredArray(key) {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeStoredArray(key, items) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, JSON.stringify(items));
  } catch {}
}

function useRoute() {
  const [route, setRoute] = useState(() => normalizeRoute(window.location.pathname));

  useEffect(() => {
    const onPopState = () => setRoute(normalizeRoute(window.location.pathname));
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  const navigate = (to) => {
    const next = normalizeRoute(to);
    if (next === route) return;
    window.history.pushState({}, "", next);
    setRoute(next);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return { route, navigate };
}

function AppLink({ href, route, navigate, children, className = "", active = false }) {
  return (
    <a
      href={href}
      className={className}
      aria-current={active ? "page" : undefined}
      onClick={(event) => {
        event.preventDefault();
        navigate(route);
      }}
    >
      {children}
    </a>
  );
}

const FEED_ACTIVITY = [
  ["Burgerverse", "$BURG", "bought", "2.4 SOL"],
  ["Combo Cash", "$MEAL", "launched", "just now"],
  ["Snack Attack", "$SNAX", "climbed", "+41.2%"],
  ["Fries Club", "$FRIES", "graduating", "82%"],
  ["Midnight Drive Thru", "$LATE", "traded", "18.6 SOL"],
];

function ActivityRail() {
  // Four identical groups keep the rail filled on ultrawide screens. Moving half
  // the full track always lands on the start of an identical group.
  const items = Array.from({ length: 4 }, () => FEED_ACTIVITY).flat();

  return (
    <aside className="activity-rail" aria-label="Recent platform activity">
      <div className="activity-rail-track">
        {items.map(([name, ticker, action, value], index) => (
          <div className="activity-rail-item" key={`${name}-${index}`}>
            <span className="activity-rail-dot" />
            <strong>{name}</strong>
            <span>{ticker}</span>
            <em>{action}</em>
            <b>{value}</b>
          </div>
        ))}
      </div>
    </aside>
  );
}

function SkeletonCard() {
  return (
    <article className="token-card token-card-compact skeleton-card">
      <div className="skeleton-block token-card-image-skeleton" />
      <div className="token-card-compact-body">
        <div className="skeleton-copy skeleton-copy-tight">
          <div className="skeleton-line medium" />
          <div className="skeleton-line short" />
        </div>
        <div className="skeleton-market-row">
          <div className="skeleton-line medium" />
          <div className="skeleton-line short" />
        </div>
        <div className="skeleton-creator-row">
          <div className="skeleton-creator-avatar" />
          <div className="skeleton-line medium" />
          <div className="skeleton-line short" />
        </div>
      </div>
    </article>
  );
}

function SkeletonTableRow() {
  return (
    <div className="token-table-row token-table-row-skeleton">
      <div className="token-table-token">
        <div className="token-table-avatar-skeleton" />
        <div className="skeleton-copy skeleton-copy-tight token-table-skeleton-copy">
          <div className="skeleton-line medium" />
          <div className="skeleton-line short" />
        </div>
      </div>
      <div className="skeleton-line short" />
      <div className="skeleton-line short" />
      <div className="skeleton-line short" />
      <div className="skeleton-line short" />
      <div className="skeleton-line short" />
    </div>
  );
}

function SearchSkeletonRow() {
  return (
    <div className="search-result-row search-result-row-skeleton">
      <div className="search-result-token">
        <div className="search-result-avatar-skeleton" />
        <div className="search-result-token-copy">
          <div className="skeleton-line medium" />
          <div className="skeleton-line short" />
        </div>
      </div>
      <div className="search-result-meta">
        <div className="search-result-stack-skeleton" />
        <div className="search-result-stack-skeleton" />
        <div className="search-result-age-skeleton" />
      </div>
    </div>
  );
}

function TokenCard({ token, navigate, viewCreator }) {
  const creatorProfile = USER_PROFILES[token.creator];

  return (
    <article
      className="token-card token-card-compact token-card-clickable"
      onClick={() => navigate(`/token/${token.slug}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          navigate(`/token/${token.slug}`);
        }
      }}
    >
      <div className="token-art token-art-compact">
        <img src={token.image} alt={token.name} className="token-art-image" />
        <span className="token-status token-status-overlay">{token.status}</span>
      </div>

      <div className="token-card-compact-body">
        <div className="token-identity">
          <h3 className="token-name">{token.name}</h3>
          <span className="token-ticker">{token.ticker}</span>
        </div>

        <div className="token-market-row">
          <div>
            <strong>{token.marketCap}</strong>
            <span>MC</span>
          </div>
        </div>

        <div className="token-creator-row">
          <span className="token-creator-avatar" aria-hidden="true">
            {creatorProfile?.avatar || token.creator.slice(0, 2).toUpperCase()}
          </span>
          <button
            type="button"
            className="token-inline-link token-creator-handle"
            onClick={(event) => {
              event.stopPropagation();
              viewCreator(token.creator);
            }}
          >
            {token.creator}
          </button>
          <span className="token-card-age">{formatMinutesAgo(token.ageMinutes)}</span>
        </div>
      </div>
    </article>
  );
}

function TokenTable({ tokens, navigate, viewCreator, isLoading }) {
  if (isLoading) {
    return (
      <div className="token-table-shell">
        <div className="token-table-head">
          <span>Token</span>
          <span>Status</span>
          <span>Market cap</span>
          <span>Volume</span>
          <span>Holders</span>
          <span>Age</span>
        </div>
        {Array.from({ length: 6 }, (_, index) => (
          <SkeletonTableRow key={index} />
        ))}
      </div>
    );
  }

  return (
    <div className="token-table-shell">
      <div className="token-table-head">
        <span>Token</span>
        <span>Status</span>
        <span>Market cap</span>
        <span>Volume</span>
        <span>Holders</span>
        <span>Age</span>
      </div>
      {tokens.map((token) => (
        <button
          key={token.slug}
          className="token-table-row"
          type="button"
          onClick={() => navigate(`/token/${token.slug}`)}
        >
          <div className="token-table-token">
            <img src={token.image} alt={token.name} className="token-table-avatar" />
            <div>
              <strong>{token.name}</strong>
              <div className="token-table-secondary">
                <span>{token.ticker}</span>
                <button
                  type="button"
                  className="token-inline-link"
                  onClick={(event) => {
                    event.stopPropagation();
                    viewCreator(token.creator);
                  }}
                >
                  @{token.creator}
                </button>
              </div>
            </div>
          </div>
          <span><span className="token-status">{token.status}</span></span>
          <strong>{token.marketCap}</strong>
          <strong>{token.volume}</strong>
          <strong>{formatNumberCompact(token.holdersValue)}</strong>
          <span>{formatMinutesAgo(token.ageMinutes)}</span>
        </button>
      ))}
    </div>
  );
}

function SearchModal({
  isOpen,
  query,
  setQuery,
  isTyping,
  results,
  recentSearches,
  recentViewed,
  tokenBySlug,
  applySearch,
  navigate,
  close,
}) {
  if (!isOpen) return null;

  const showRecents = !query.trim();

  return (
    <div className="search-overlay" role="dialog" aria-modal="true">
      <div className="search-backdrop" onClick={close} />
      <div className="search-modal">
        <div className="search-modal-bar">
          <img src="/icons/search.svg" alt="" className="search-modal-icon" />
          <input
            autoFocus
            type="text"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Search by name, ticker, or creator"
          />
          <button className="search-close" type="button" onClick={close} aria-label="Close search">
            ×
          </button>
        </div>

        {showRecents ? (
          <div className="search-modal-body">
            <div className="search-block">
              <div className="search-block-head">
                <h3>Recent searches</h3>
              </div>
              <div className="search-chip-list">
                {recentSearches.length ? recentSearches.map((item) => (
                  <button key={item} type="button" className="search-chip" onClick={() => setQuery(item)}>
                    {item}
                  </button>
                )) : (
                  <p className="search-empty">Searches you make here will show up for quick access.</p>
                )}
              </div>
            </div>

            <div className="search-block">
              <div className="search-block-head">
                <h3>Recently viewed</h3>
              </div>
              <div className="search-results-list">
                {recentViewed.length ? recentViewed.map((slug) => {
                  const token = tokenBySlug[slug];
                  if (!token) return null;
                  return (
                    <button
                      key={slug}
                      className="search-result-row"
                      type="button"
                      onClick={() => {
                        close();
                        navigate(`/token/${token.slug}`);
                      }}
                    >
                      <div className="search-result-token">
                        <img src={token.image} alt={token.name} className="search-result-avatar" />
                        <div className="search-result-token-copy">
                          <strong>{token.name}</strong>
                          <span>{token.ticker}</span>
                        </div>
                      </div>
                      <div className="search-result-meta">
                        <div className="search-result-stack">
                          <span>Status</span>
                          <strong>{token.status}</strong>
                        </div>
                        <div className="search-result-stack">
                          <span>Mcap</span>
                          <strong>{token.marketCap}</strong>
                        </div>
                        <div className="search-result-age">{formatMinutesAgo(token.ageMinutes)}</div>
                      </div>
                    </button>
                  );
                }) : (
                  <p className="search-empty">Tokens you open from the feed will collect here.</p>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div className="search-modal-body">
            <div className="search-block-head search-block-head-results">
              <h3>Search results</h3>
              <button className="search-view-all" type="button" onClick={() => applySearch(query)}>
                View all results →
              </button>
            </div>
            <div className="search-results-list">
              {isTyping ? (
                Array.from({ length: 5 }, (_, index) => <SearchSkeletonRow key={index} />)
              ) : results.length ? (
                results.map((token) => (
                  <button
                    key={token.slug}
                    className="search-result-row"
                    type="button"
                    onClick={() => {
                      close();
                      navigate(`/token/${token.slug}`);
                    }}
                  >
                    <div className="search-result-token">
                      <img src={token.image} alt={token.name} className="search-result-avatar" />
                      <div className="search-result-token-copy">
                        <strong>{token.name}</strong>
                        <span>{token.ticker} · @{token.creator}</span>
                      </div>
                    </div>
                    <div className="search-result-meta">
                      <div className="search-result-stack">
                        <span>Status</span>
                        <strong>{token.status}</strong>
                      </div>
                      <div className="search-result-stack">
                        <span>Mcap</span>
                        <strong>{token.marketCap}</strong>
                      </div>
                      <div className="search-result-age">{formatMinutesAgo(token.ageMinutes)}</div>
                    </div>
                  </button>
                ))
              ) : (
                <p className="search-empty">No matching launches on the board yet.</p>
              )}
            </div>
            <div className="search-legend">
              <span><kbd>↵</kbd> to search</span>
              <span><kbd>esc</kbd> to close</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function TokensPage({
  isLoading,
  tokens,
  navigate,
  viewMode,
  setViewMode,
  sortMode,
  setSortMode,
  filterMode,
  setFilterMode,
  appliedSearch,
  clearSearch,
  viewCreator,
}) {
  const sortLabelMap = {
    activity: "Activity",
    marketCap: "Market Cap",
    volume: "Volume",
    newest: "Newest",
    oldest: "Oldest",
  };

  const filterOptions = ["All", "Live", "Hot", "New", "Trending", "Early", "Soon"];

  return (
    <>
      <section className="feed-banner" aria-label="HappiMeal launchpad">
        <img src="/banner.png" alt="HappiMeal token launchpad" />
      </section>

      <section className="feed-metrics" aria-label="Launchpad overview">
        <div className="metric-card metric-card-hot">
          <span className="metric-label">Now serving</span>
          <strong>124 live tokens</strong>
        </div>
        <div className="metric-card">
          <span className="metric-label">24h volume</span>
          <strong>$2.7M</strong>
        </div>
        <div className="metric-card">
          <span className="metric-label">Graduating soon</span>
          <strong>18 projects</strong>
        </div>
      </section>

      <section className="toolbar-card">
        <div className="toolbar-left">
          <label className="toolbar-select-shell">
            <span>Sort</span>
            <select value={sortMode} onChange={(event) => setSortMode(event.target.value)}>
              {Object.entries(sortLabelMap).map(([value, label]) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </label>

          <label className="toolbar-select-shell">
            <span>Filter</span>
            <select value={filterMode} onChange={(event) => setFilterMode(event.target.value)}>
              {filterOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div className="toolbar-right">
          {appliedSearch ? (
            <div className="search-applied-chip">
              <span>Search</span>
              <strong>{appliedSearch}</strong>
              <button type="button" onClick={clearSearch} aria-label="Clear search">
                ×
              </button>
            </div>
          ) : null}

          <div className="layout-toggle" aria-label="Feed layout">
            <button
              className={`layout-toggle-btn ${viewMode === "grid" ? "is-active" : ""}`}
              type="button"
              onClick={() => setViewMode("grid")}
            >
              Grid
            </button>
            <button
              className={`layout-toggle-btn ${viewMode === "table" ? "is-active" : ""}`}
              type="button"
              onClick={() => setViewMode("table")}
            >
              Table
            </button>
          </div>
        </div>
      </section>

      {viewMode === "grid" ? (
        <section className="tokens-grid">
          {isLoading
            ? Array.from({ length: 6 }, (_, index) => <SkeletonCard key={index} />)
            : tokens.map((token) => (
                <TokenCard
                  key={token.slug}
                  token={token}
                  navigate={navigate}
                  viewCreator={viewCreator}
                />
              ))}
        </section>
      ) : (
        <TokenTable
          tokens={tokens}
          navigate={navigate}
          viewCreator={viewCreator}
          isLoading={isLoading}
        />
      )}
    </>
  );
}

function CreatePage() {
  return (
    <section className="mock-page-shell">
      <div className="mock-page-header">
        <div>
          <span className="section-kicker">CREATE</span>
          <h1 className="mock-page-title">Launch a new token</h1>
          <p className="mock-page-copy">
            Set up art, socials, launch copy, and the curve profile in a simple, fast product flow.
          </p>
        </div>
        <div className="mock-page-badge">Create flow</div>
      </div>

      <div className="create-layout">
        <section className="side-card create-form-card">
          <div className="create-section">
            <div className="create-section-heading">
              <span>01</span>
              <div>
                <h2>Token basics</h2>
                <p>Name the token and give people a reason to care.</p>
              </div>
            </div>
            <div className="form-grid">
              <label className="field">
                <span>Token name</span>
                <input type="text" placeholder="Happi Burger" />
              </label>
              <label className="field">
                <span>Ticker</span>
                <input type="text" placeholder="$BURG" />
              </label>
              <label className="field field-full">
                <span>Description</span>
                <textarea placeholder="Tell the internet why this token exists." rows="5" />
              </label>
            </div>
          </div>

          <div className="create-section">
            <div className="create-section-heading">
              <span>02</span>
              <div>
                <h2>Artwork</h2>
                <p>Use a square image that stays recognizable at feed size.</p>
              </div>
            </div>
            <label className="field">
              <span>Token image</span>
              <div className="upload-shell">
                <div className="upload-mark">+</div>
                <strong>Choose image</strong>
                <small>PNG, JPG or WEBP · 5 MB max</small>
              </div>
            </label>
          </div>

          <div className="create-section">
            <div className="create-section-heading">
              <span>03</span>
              <div>
                <h2>Socials</h2>
                <p>Optional links make the launch easier to verify and follow.</p>
              </div>
            </div>
            <div className="form-grid">
              <label className="field field-full">
                <span>Website</span>
                <input type="text" placeholder="https://happimeal.fun" />
              </label>
              <label className="field">
                <span>X / Twitter</span>
                <input type="text" placeholder="@happimeal" />
              </label>
              <label className="field">
                <span>Telegram</span>
                <input type="text" placeholder="t.me/happimeal" />
              </label>
            </div>
          </div>
        </section>

        <aside className="create-sidebar">
          <section className="side-card create-settings-card">
            <span className="section-kicker">SETTINGS</span>
            <h3>Launch defaults</h3>
            <ul className="mini-list">
              <li>
                <span>Supply</span>
                <strong>1B</strong>
              </li>
              <li>
                <span>Curve</span>
                <strong>Standard</strong>
              </li>
              <li>
                <span>Trading fee</span>
                <strong>1.0%</strong>
              </li>
            </ul>
          </section>

          <section className="side-card create-summary-card">
            <span className="section-kicker">SUMMARY</span>
            <h3>Ready to cook</h3>
            <p className="side-note">
              Once launched, your token appears in the board, search, activity rail, and creator profiles automatically.
            </p>
            <div className="create-actions">
              <button className="primary-btn full-width" type="button">
                Create token
              </button>
              <button className="ghost-btn full-width" type="button">
                Save draft
              </button>
            </div>
          </section>
        </aside>
      </div>
    </section>
  );
}

function ProfilePage({ connected, navigate, connectedProfile, tokenBySlug }) {
  if (!connected || !connectedProfile) {
    return (
      <section className="mock-page-shell">
        <div className="mock-page-header">
          <div>
            <span className="section-kicker">PROFILE</span>
            <h1 className="mock-page-title">Your activity tray</h1>
            <p className="mock-page-copy">
              Connect a wallet to preview positions, watchlists, and launch history in one place.
            </p>
          </div>
          <div className="mock-page-badge">Wallet required</div>
        </div>
      </section>
    );
  }

  return (
    <section className="mock-page-shell">
      <div className="mock-page-header">
        <div>
          <span className="section-kicker">PROFILE</span>
          <h1 className="mock-page-title">Your activity tray</h1>
          <p className="mock-page-copy">
            Keep your bags, creator pages, and recent participation in one cleaner dashboard.
          </p>
        </div>
        <div className="mock-page-badge">Connected</div>
      </div>

      <div className="profile-layout">
        <section className="side-card profile-summary-card">
          <div className="profile-summary-top">
            <div className="profile-avatar">{connectedProfile.avatar}</div>
            <div>
              <strong className="profile-wallet">{connectedProfile.wallet}</strong>
              <p className="side-note">@{connectedProfile.handle} · {connectedProfile.role}</p>
            </div>
          </div>

          <div className="profile-stat-grid">
            <div className="metric-card">
              <span className="metric-label">Portfolio value</span>
              <strong>$3,537</strong>
            </div>
            <div className="metric-card">
              <span className="metric-label">Tokens held</span>
              <strong>12</strong>
            </div>
            <div className="metric-card">
              <span className="metric-label">Created</span>
              <strong>{connectedProfile.launches}</strong>
            </div>
          </div>
        </section>

        <section className="side-card profile-table-card">
          <div className="section-heading">
            <div>
              <span className="section-kicker">POSITIONS</span>
              <h2>Open bags</h2>
            </div>
          </div>

          <div className="positions-list">
            {PROFILE_POSITIONS.map((position) => {
              const token = tokenBySlug[position.slug];
              if (!token) return null;
              return (
                <button
                  className="position-row position-row-button"
                  key={position.slug}
                  type="button"
                  onClick={() => navigate(`/token/${position.slug}`)}
                >
                  <div>
                    <strong>{token.name}</strong>
                    <span>{token.ticker}</span>
                  </div>
                  <div>
                    <strong>{position.amount}</strong>
                    <span>Tokens</span>
                  </div>
                  <div>
                    <strong>{position.value}</strong>
                    <span>Value</span>
                  </div>
                  <div className={position.pnl.startsWith("-") ? "pnl-negative" : "pnl-positive"}>
                    <strong>{position.pnl}</strong>
                    <span>P&amp;L</span>
                  </div>
                </button>
              );
            })}
          </div>
        </section>
      </div>
    </section>
  );
}

function UserPage({ profile, tokenBySlug, navigate }) {
  const createdTokens = profile.created.map((slug) => tokenBySlug[slug]).filter(Boolean);
  return (
    <section className="mock-page-shell">
      <div className="mock-page-header user-header">
        <div className="user-header-main">
          <div className="user-header-avatar">{profile.avatar}</div>
          <div>
            <span className="section-kicker">CREATOR PROFILE</span>
            <h1 className="mock-page-title">@{profile.handle}</h1>
            <p className="mock-page-copy">{profile.bio}</p>
          </div>
        </div>
        <div className="user-header-meta">
          <div className="mock-page-badge">{profile.role}</div>
          <span>{profile.wallet}</span>
        </div>
      </div>

      <div className="profile-layout">
        <section className="side-card profile-summary-card">
          <div className="profile-stat-grid user-stat-grid">
            <div className="metric-card">
              <span className="metric-label">Followers</span>
              <strong>{profile.followers}</strong>
            </div>
            <div className="metric-card">
              <span className="metric-label">Following</span>
              <strong>{profile.following}</strong>
            </div>
            <div className="metric-card">
              <span className="metric-label">Launches</span>
              <strong>{profile.launches}</strong>
            </div>
            <div className="metric-card">
              <span className="metric-label">Volume</span>
              <strong>{profile.volume}</strong>
            </div>
          </div>

          <div className="user-holding-list">
            {profile.holdings.map((item) => (
              <div className="user-holding-row" key={item.label}>
                <span>{item.label}</span>
                <strong>{item.value}</strong>
                <em>{item.meta}</em>
              </div>
            ))}
          </div>
        </section>

        <section className="side-card profile-table-card">
          <div className="section-heading">
            <div>
              <span className="section-kicker">CREATED</span>
              <h2>Launches on the board</h2>
            </div>
          </div>
          <div className="related-list">
            {createdTokens.map((token) => (
              <button className="related-row" type="button" key={token.slug} onClick={() => navigate(`/token/${token.slug}`)}>
                <img src={token.image} alt={token.name} />
                <div>
                  <strong>{token.name}</strong>
                  <span>{token.ticker}</span>
                </div>
                <div className="related-meta">
                  <strong>{token.marketCap}</strong>
                  <span>{token.change}</span>
                </div>
              </button>
            ))}
          </div>
          <div className="user-activity-card">
            <span className="section-kicker">RECENT ACTIVITY</span>
            <ul className="user-activity-list">
              {profile.activity.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    </section>
  );
}

function BondingCard({ token }) {
  return (
    <section className="bonding-card">
      <div className="bonding-head">
        <div>
          <span className="section-kicker">Bonding Curve</span>
          <h3>Progress</h3>
        </div>
        <strong>{token.bondProgress}%</strong>
      </div>

      <div className="bonding-track" aria-hidden="true">
        <div className="bonding-track-fill" style={{ width: `${token.bondProgress}%` }} />
      </div>

      <div className="bonding-grid">
        <div className="bonding-stat">
          <span>To graduate</span>
          <strong>{token.graduationMcap}</strong>
        </div>
        <div className="bonding-stat">
          <span>Amount required</span>
          <strong>{token.amountRequired}</strong>
        </div>
      </div>

      <div className="bonding-grid bonding-grid-full">
        <div className="bonding-stat">
          <span>Est. USD required</span>
          <strong>{token.amountRequiredUsd}</strong>
        </div>
      </div>
    </section>
  );
}

function TokenDetailPage({ token, navigate, theme, viewCreator }) {
  const [activeTab, setActiveTab] = useState("Trades");
  const [tradeSide, setTradeSide] = useState("buy");

  const relatedTokens = TOKENS.filter((item) => item.slug !== token.slug).slice(0, 3);
  const liveChartUrl = `${LIVE_CHART_BASE_URL}&theme=${theme === "dark" ? "dark" : "light"}`;

  return (
    <section className="detail-shell">
      <section className="detail-hero">
        <div className="detail-hero-main">
          <button className="back-link" type="button" onClick={() => navigate("/")}>
            ← Back to feed
          </button>

          <div className="detail-token-row">
            <div className="detail-token-art">
              <img src={token.image} alt={token.name} className="detail-token-image" />
            </div>

            <div className="detail-token-copy">
              <div className="detail-token-topline">
                <span className="detail-chain-pill">{token.chain}</span>
                <span className="detail-status-pill">{token.status}</span>
              </div>
              <h1 className="detail-title">{token.name}</h1>
              <div className="detail-subtitle-row">
                <span className="detail-ticker">{token.ticker}</span>
                <button type="button" className="token-inline-link token-inline-link-detail" onClick={() => viewCreator(token.creator)}>
                  @{token.creator}
                </button>
                <span>{formatMinutesAgo(token.ageMinutes)}</span>
              </div>
              <p className="detail-copy">{token.about}</p>

              <div className="detail-link-row">
                <a href="/" onClick={(event) => event.preventDefault()} className="ghost-chip">
                  <img src="/icons/web.svg" alt="" className="chip-icon" />
                  {token.website}
                </a>
                <a href="/" onClick={(event) => event.preventDefault()} className="ghost-chip">
                  <img src="/icons/x.svg" alt="" className="chip-icon" />
                  {token.social}
                </a>
                <button className="ghost-chip" type="button">
                  {token.contract}
                </button>
              </div>
            </div>
          </div>
        </div>

        <aside className="detail-trade-card">
          <div className="trade-tabs">
            <button className={`trade-tab ${tradeSide === "buy" ? "is-active" : ""}`} type="button" onClick={() => setTradeSide("buy")}>
              Buy
            </button>
            <button className={`trade-tab ${tradeSide === "sell" ? "is-active" : ""}`} type="button" onClick={() => setTradeSide("sell")}>
              Sell
            </button>
          </div>

          <div className="trade-card-head">
            <div>
              <span className="metric-label">Price</span>
              <strong>{token.price}</strong>
            </div>
            <div className="trade-change-positive">{token.change}</div>
          </div>

          <label className="trade-input-shell">
            <span>Amount</span>
            <input type="text" placeholder="0.00 SOL" />
          </label>

          <div className="trade-presets">
            <button className="trade-preset" type="button">0.5 SOL</button>
            <button className="trade-preset" type="button">1 SOL</button>
            <button className="trade-preset" type="button">2 SOL</button>
            <button className="trade-preset" type="button">Max</button>
          </div>

          <button className="yellow-btn full-width" type="button">
            {tradeSide === "buy" ? `Buy ${token.ticker}` : `Sell ${token.ticker}`}
          </button>

          <div className="trade-card-notes">
            <div>
              <span>Pool liquidity</span>
              <strong>{token.volume}</strong>
            </div>
            <div>
              <span>Holders</span>
              <strong>{token.holders}</strong>
            </div>
          </div>

        </aside>
      </section>

      <section className="detail-grid detail-grid-independent">
        <div className="detail-main-column">
          <section className="side-card detail-chart-card">
            <div className="section-heading">
              <div>
                <span className="section-kicker">CHART</span>
                <h2>{token.name} momentum</h2>
              </div>
              <div className="time-pills">
                <button className="time-pill is-active" type="button">5m</button>
                <button className="time-pill" type="button">1h</button>
                <button className="time-pill" type="button">6h</button>
                <button className="time-pill" type="button">24h</button>
              </div>
            </div>

            <div className="chart-surface">
              <iframe
                key={liveChartUrl}
                className="live-chart-frame"
                src={liveChartUrl}
                title="Live market chart"
                loading="lazy"
                allow="clipboard-write"
              />
            </div>

            <div className="detail-stat-row">
              <div className="detail-stat-card">
                <span>Market cap</span>
                <strong>{token.marketCap}</strong>
              </div>
              <div className="detail-stat-card">
                <span>24h volume</span>
                <strong>{token.volume}</strong>
              </div>
              <div className="detail-stat-card">
                <span>ATH</span>
                <strong>{token.ath}</strong>
              </div>
              <div className="detail-stat-card">
                <span>Holders</span>
                <strong>{token.holders}</strong>
              </div>
            </div>
          </section>

          <section className="side-card detail-tabs-card">
            <div className="detail-tablist">
              {DETAIL_TABS.map((tab) => (
                <button
                  key={tab}
                  className={`detail-tab-btn ${activeTab === tab ? "is-active" : ""}`}
                  type="button"
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>

            {activeTab === "Trades" && (
              <div className="detail-table">
                <div className="detail-table-header">
                  <span>Wallet</span>
                  <span>Side</span>
                  <span>Amount</span>
                  <span>Tokens</span>
                  <span>Time</span>
                </div>
                {token.trades.map((trade, index) => (
                  <div className="detail-table-row" key={`${trade.wallet}-${index}`}>
                    <span>{trade.wallet}</span>
                    <span className={trade.side === "Buy" ? "trade-buy" : "trade-sell"}>{trade.side}</span>
                    <span>{trade.amount}</span>
                    <span>{trade.tokens}</span>
                    <span>{trade.time}</span>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "Holders" && (
              <div className="detail-table">
                <div className="detail-table-header">
                  <span>Holder</span>
                  <span>Share</span>
                  <span>Entry</span>
                  <span>P&amp;L</span>
                </div>
                {token.holdersTable.map((holder, index) => (
                  <div className="detail-table-row detail-table-row-four" key={`${holder.wallet}-${index}`}>
                    <span>{holder.wallet}</span>
                    <span>{holder.share}</span>
                    <span>{holder.entry}</span>
                    <span>{holder.pnl}</span>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "Callouts" && (
              <div className="callout-list">
                {token.comments.map((comment, index) => (
                  <article className="callout-card" key={`${comment.user}-${index}`}>
                    <div className="callout-top">
                      <div>
                        <strong>{comment.user}</strong>
                        <span>{comment.age}</span>
                      </div>
                      <span className="callout-multiple">{comment.conviction}</span>
                    </div>
                    <p>{comment.text}</p>
                  </article>
                ))}
              </div>
            )}
          </section>
        </div>

        <aside className="detail-side-column">
          <BondingCard token={token} />

          <section className="side-card">
            <span className="section-kicker">COMMUNITY</span>
            <h3>{token.ticker} is active</h3>
            <p className="side-note">
              The feed is moving, replies are active, and the launch has enough energy to feel alive even before you open the chart.
            </p>
            <div className="mini-list">
              <li>
                <span>Creator</span>
                <button type="button" className="token-inline-link token-inline-link-plain" onClick={() => viewCreator(token.creator)}>
                  @{token.creator}
                </button>
              </li>
              <li>
                <span>Website</span>
                <strong>{token.website}</strong>
              </li>
              <li>
                <span>Age</span>
                <strong>{formatMinutesAgo(token.ageMinutes)}</strong>
              </li>
            </div>
          </section>

          <section className="side-card">
            <span className="section-kicker">RELATED</span>
            <h3>Keep browsing</h3>
            <div className="related-list">
              {relatedTokens.map((item) => (
                <button className="related-row" type="button" key={item.slug} onClick={() => navigate(`/token/${item.slug}`)}>
                  <img src={item.image} alt={item.name} />
                  <div>
                    <strong>{item.name}</strong>
                    <span>{item.ticker}</span>
                  </div>
                  <div className="related-meta">
                    <strong>{item.marketCap}</strong>
                    <span>{item.change}</span>
                  </div>
                </button>
              ))}
            </div>
          </section>
        </aside>
      </section>
    </section>
  );
}

function FooterBar() {
  return (
    <footer className="site-footer">
      <div className="site-footer-copy">
        <strong>HappiMeal</strong>
        <span>Tokens are risky. Trade responsibly.</span>
      </div>
      <div className="site-footer-links">
        {FOOTER_LINKS.map((link) => (
          <a key={link.label} href={link.href} onClick={(event) => event.preventDefault()} className="site-footer-link">
            <img src={link.icon} alt="" />
            <span>{link.label}</span>
          </a>
        ))}
      </div>
    </footer>
  );
}

function NotFoundPage({ navigate }) {
  return (
    <section className="mock-page-shell">
      <div className="mock-page-header">
        <div>
          <span className="section-kicker">TOKEN</span>
          <h1 className="mock-page-title">That page is not on the menu.</h1>
          <p className="mock-page-copy">
            Head back to the board and pick another launch from the HappiMeal feed.
          </p>
        </div>
        <button className="yellow-btn" type="button" onClick={() => navigate("/")}>
          Back to tokens
        </button>
      </div>
    </section>
  );
}

export default function App() {
  const { route, navigate } = useRoute();
  const [isLoading, setIsLoading] = useState(true);
  const [theme, setTheme] = useState(getInitialTheme);
  const [viewMode, setViewMode] = useState("grid");
  const [sortMode, setSortMode] = useState("activity");
  const [filterMode, setFilterMode] = useState("All");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isSearchTyping, setIsSearchTyping] = useState(false);
  const [recentSearches, setRecentSearches] = useState(() => readStoredArray(SEARCH_KEY));
  const [recentViewed, setRecentViewed] = useState(() => readStoredArray(VIEWED_KEY));
  const [appliedSearch, setAppliedSearch] = useState("");
  const [isWalletConnected, setIsWalletConnected] = useState(false);

  const tokenBySlug = useMemo(
    () => Object.fromEntries(TOKENS.map((token) => [token.slug, token])),
    []
  );

  const connectedProfile = USER_PROFILES.comboalpha;

  const detailToken = route.startsWith("/token/")
    ? TOKENS.find((token) => route === `/token/${token.slug}`)
    : null;
  const userProfile = route.startsWith("/user/")
    ? USER_PROFILES[route.replace("/user/", "")]
    : null;

  useEffect(() => {
    const timeout = window.setTimeout(() => setIsLoading(false), 900);
    return () => window.clearTimeout(timeout);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    window.localStorage.setItem("happimeal-theme", theme);
  }, [theme]);

  useEffect(() => {
    if (!isSearchOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") setIsSearchOpen(false);
      if (event.key === "Enter" && searchQuery.trim()) {
        applySearchQuery(searchQuery);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  });

  useEffect(() => {
    if (!isSearchOpen) return;
    setIsSearchTyping(true);
    const timeout = window.setTimeout(() => {
      setDebouncedSearch(searchQuery.trim());
      setIsSearchTyping(false);
    }, SEARCH_DEBOUNCE_MS);
    return () => window.clearTimeout(timeout);
  }, [searchQuery, isSearchOpen]);

  useEffect(() => {
    if (!detailToken) return;
    setRecentViewed((current) => {
      const next = [detailToken.slug, ...current.filter((item) => item !== detailToken.slug)].slice(0, 6);
      writeStoredArray(VIEWED_KEY, next);
      return next;
    });
  }, [detailToken]);

  const filteredTokens = useMemo(() => {
    let rows = [...TOKENS];
    if (filterMode !== "All") {
      rows = rows.filter((token) => token.status === filterMode);
    }
    if (appliedSearch.trim()) {
      const q = appliedSearch.trim().toLowerCase();
      rows = rows.filter((token) => scoreTokenSearch(token, q) > 0);
    }
    rows.sort((a, b) => {
      if (sortMode === "marketCap") return b.marketCapValue - a.marketCapValue;
      if (sortMode === "volume") return b.volumeValue - a.volumeValue;
      if (sortMode === "newest") return a.ageMinutes - b.ageMinutes;
      if (sortMode === "oldest") return b.ageMinutes - a.ageMinutes;
      const scoreA = a.volumeValue + a.marketCapValue * 0.25 - a.ageMinutes * 220;
      const scoreB = b.volumeValue + b.marketCapValue * 0.25 - b.ageMinutes * 220;
      return scoreB - scoreA;
    });
    return rows;
  }, [filterMode, sortMode, appliedSearch]);

  const searchResults = useMemo(() => {
    const q = debouncedSearch.trim().toLowerCase();
    if (!q) return [];
    return [...TOKENS]
      .map((token) => ({ token, score: scoreTokenSearch(token, q) }))
      .filter((entry) => entry.score > 0)
      .sort((a, b) => {
        if (b.score !== a.score) return b.score - a.score;
        if (b.token.marketCapValue !== a.token.marketCapValue) {
          return b.token.marketCapValue - a.token.marketCapValue;
        }
        return b.token.volumeValue - a.token.volumeValue;
      })
      .slice(0, 5)
      .map((entry) => entry.token);
  }, [debouncedSearch]);

  const toggleTheme = () => {
    setTheme((current) => (current === "dark" ? "light" : "dark"));
  };

  const handleWalletAction = () => {
    if (isWalletConnected) {
      navigate("/profile");
      return;
    }
    setIsWalletConnected(true);
  };

  const viewCreator = (handle) => {
    navigate(`/user/${handle}`);
  };

  const applySearchQuery = (value) => {
    const normalized = String(value || "").trim();
    if (!normalized) return;
    setAppliedSearch(normalized);
    setRecentSearches((current) => {
      const next = [normalized, ...current.filter((item) => item.toLowerCase() !== normalized.toLowerCase())].slice(0, 6);
      writeStoredArray(SEARCH_KEY, next);
      return next;
    });
    setIsSearchOpen(false);
    navigate("/");
  };

  const clearSearch = () => {
    setAppliedSearch("");
  };

  const openSearch = () => {
    setSearchQuery("");
    setDebouncedSearch("");
    setIsSearchTyping(false);
    setIsSearchOpen(true);
  };

  useEffect(() => {
    const onSearchShortcut = (event) => {
      const tagName = event.target?.tagName?.toLowerCase();
      if (event.key !== "/" || tagName === "input" || tagName === "textarea") return;
      event.preventDefault();
      openSearch();
    };
    window.addEventListener("keydown", onSearchShortcut);
    return () => window.removeEventListener("keydown", onSearchShortcut);
  });

  return (
    <div className="page-shell">
      <header className="topbar">
        <AppLink href="/" route="/" navigate={navigate} className="brand" active={route === "/"}>
          <img src="/logo/happimeal.png" alt="Happimeal" className="brand-logo" />
          <div className="brand-copy">
            <span className="brand-name">Happimeal</span>
            <span className="brand-tag">Fast-food style coin launches</span>
          </div>
        </AppLink>

        <button className="header-search" type="button" onClick={openSearch}>
          <img src="/icons/search.svg" alt="" />
          <span>Search tokens, symbols, or creators</span>
          <kbd>/</kbd>
        </button>

        <div className="topbar-actions">
          <button
            className="ghost-btn theme-toggle"
            type="button"
            onClick={toggleTheme}
            aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
          >
            <span className="theme-toggle-label">{theme === "dark" ? "Light mode" : "Dark mode"}</span>
          </button>
          <button className="ghost-btn wallet-btn" type="button" onClick={handleWalletAction}>
            <img src="/icons/profile.svg" alt="" className="wallet-btn-icon" />
            <span>{isWalletConnected ? shortAddress(connectedProfile.wallet) : "Connect"}</span>
          </button>
          <button className="primary-btn" type="button" onClick={() => navigate("/create")}>
            Launch
          </button>
        </div>
      </header>

      <ActivityRail />

      <main className="layout">
        {route === "/" && (
          <TokensPage
            isLoading={isLoading}
            tokens={filteredTokens}
            navigate={navigate}
            viewMode={viewMode}
            setViewMode={setViewMode}
            sortMode={sortMode}
            setSortMode={setSortMode}
            filterMode={filterMode}
            setFilterMode={setFilterMode}
            appliedSearch={appliedSearch}
            clearSearch={clearSearch}
            viewCreator={viewCreator}
          />
        )}
        {route === "/create" && <CreatePage />}
        {route === "/profile" && (
          <ProfilePage
            connected={isWalletConnected}
            navigate={navigate}
            connectedProfile={connectedProfile}
            tokenBySlug={tokenBySlug}
          />
        )}
        {route.startsWith("/user/") && userProfile && (
          <UserPage profile={userProfile} tokenBySlug={tokenBySlug} navigate={navigate} />
        )}
        {route.startsWith("/user/") && !userProfile && <NotFoundPage navigate={navigate} />}
        {route.startsWith("/token/") && detailToken && (
          <TokenDetailPage token={detailToken} navigate={navigate} theme={theme} viewCreator={viewCreator} />
        )}
        {route.startsWith("/token/") && !detailToken && <NotFoundPage navigate={navigate} />}
      </main>

      <FooterBar />

      <SearchModal
        isOpen={isSearchOpen}
        query={searchQuery}
        setQuery={setSearchQuery}
        isTyping={isSearchTyping}
        results={searchResults}
        recentSearches={recentSearches}
        recentViewed={recentViewed}
        tokenBySlug={tokenBySlug}
        applySearch={applySearchQuery}
        navigate={navigate}
        close={() => setIsSearchOpen(false)}
      />
    </div>
  );
}
